import {Quality} from "@/store/player/types";
import PlayerStore from "@/store/player";

export default class QualityUtils {

    /**
     * Автоопределение стоит денег (performance.memory + try/catch), а getQuality() дёргается
     * очень часто: из CU.windowWidth(), из SpineUtils.resolveConfig() на КАЖДОЕ создание спрайта.
     * Железо за сессию не меняется, поэтому автоопределение считаем один раз.
     * Явный выбор игрока в настройках читается каждый раз и кэш не трогает.
     */
    private static autoQuality: Quality | undefined;

    public static getReccommendedWidth() {
        let quality = QualityUtils.getQuality();

        switch (quality) {
            case Quality.LOWEST:
                return 450;
            case Quality.LOW:
                return 500;
            case Quality.AUTO:
            case Quality.STANDARD:
                return 600;
            case Quality.HIGH:
                return 768;
        }
    }

    /** LOW и LOWEST - режимы для слабых устройств, скелетные анимации в них отключены. */
    public static isLowQuality(): boolean {
        let quality = QualityUtils.getQuality();
        return quality === Quality.LOW || quality === Quality.LOWEST;
    }

    public static getQuality(): Quality {

        let quality = PlayerStore.getQuality();

        if (quality && quality !== Quality.AUTO) {
            return quality;
        }

        if (QualityUtils.autoQuality === undefined) {
            QualityUtils.autoQuality = QualityUtils.detectQuality();
        }

        return QualityUtils.autoQuality;
    }

    private static detectQuality(): Quality {

        // performance.memory есть только в Chromium. Там это самый точный сигнал: лимит кучи
        // напрямую зависит от объёма RAM устройства.
        try {
            // @ts-ignore
            let availableMemory = performance.memory.jsHeapSizeLimit / 1000000; // will give you the JS heap size

            if (availableMemory > 1100) { // 1130 = 6GB RAM
                return Quality.HIGH;
            } else if (availableMemory > 600) { // 793 = 3GB RAM
                return Quality.STANDARD;
            } else if (availableMemory > 450) {  // 491 = 2GB RAM
                return Quality.LOW;
            } else {
                return Quality.LOWEST;
            }

        } catch (e) {
            // do nothing
        }

        // Вне Chromium (iOS Safari, Firefox, часть webview) performance.memory нет, и раньше мы
        // отсюда уходили в HIGH - то есть слабое устройство получало канвас 768px и все шейдеры.
        // deviceMemory отдаёт объём RAM в гигабайтах и округлён вниз до степени двойки.
        try {
            // @ts-ignore
            const deviceMemory: number | undefined = navigator.deviceMemory;
            if (typeof deviceMemory === 'number' && deviceMemory > 0) {
                if (deviceMemory <= 1) {
                    return Quality.LOWEST;
                } else if (deviceMemory <= 2) {
                    return Quality.LOW;
                } else if (deviceMemory <= 4) {
                    return Quality.STANDARD;
                }
                return Quality.HIGH;
            }
        } catch (e) {
            // do nothing
        }

        // Сигналов нет вообще. Не занижаем: реальную просадку добьёт адаптивная деградация
        // эффектов в RoadScene, она смотрит на фактический FPS, а не на догадки о железе.
        return Quality.HIGH;
    }
}
